import PropTypes from 'prop-types';
import React from 'react';

import '@components/common/checkbox/styles/checkbox.scss';

/**
 * Section-only checkbox for "Current page" / "All pages" options.
 * Keeps the visible label in tab order (Enter/Space toggles) while the native
 * input stays off the tab sequence for keyboard users — without changing the
 * shared Checkbox component.
 */
const SectionTitleSelectionCheckbox = ({
  ariaLabel,
  checked,
  children,
  className,
  datakey,
  includeInTabOrder,
  onToggle,
}) => {
  const handleLabelKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle(event);
    }
  };

  return (
    <div className={`checkbox-content-container md no-print align-null ${className}`.trim()}>
      <span className="input-container">
        <input
          id={datakey}
          aria-hidden="true"
          checked={checked}
          className="c-custom-checkbox"
          data-testid={`checkbox-input-${datakey}`}
          onChange={onToggle}
          tabIndex={-1}
          type="checkbox"
          value={checked ? 'checked' : 0}
        />
        <label
          aria-hidden="true"
          className={`checkbox-overlay ${checked ? 'checked' : 'c-custom-checkbox-hover'}`}
          data-key={datakey}
          htmlFor={datakey}
        />
      </span>
      <span
        aria-checked={checked}
        aria-label={ariaLabel}
        className="checkbox-title section-title-selection-option-label"
        onClick={onToggle}
        onKeyDown={handleLabelKeyDown}
        role="checkbox"
        tabIndex={includeInTabOrder ? 0 : -1}
      >
        {children}
      </span>
    </div>
  );
};

SectionTitleSelectionCheckbox.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  datakey: PropTypes.string.isRequired,
  includeInTabOrder: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

SectionTitleSelectionCheckbox.defaultProps = {
  className: '',
  includeInTabOrder: true,
};

export default SectionTitleSelectionCheckbox;
